module.exports = __webpack_public_path__ + "static/DPF-Deckel-c3f46ec62c961e8bebd4440fead3f57c.jpg";